import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IqacheadingListComponent } from './iqacheading-list/iqacheading-list.component';
import { IqacheadingCreateComponent } from './iqacheading-create/iqacheading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: IqacheadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: IqacheadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'iqac-heading-create/:id',
        component: IqacheadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IqacHeadingRoutingModule { }
